import mixpanel from 'mixpanel-browser';

let isInitialized = false;

export const initMixpanel = (token: string) => {
    if (isInitialized) {
        return;
    }

    mixpanel.init(token, {
        autocapture: false,
        record_sessions_percent: 0,
        ignore_dnt: true, // Ignore browser's DO_NOT_TRACK setting to ensure events are tracked
    });

    isInitialized = true;
};

export const identifyMixpanelUser = (userId: string, traits?: Record<string, any>) => {
    if (!isInitialized) {
        return;
    }

    mixpanel.identify(userId);

    if (traits) {
        mixpanel.people.set(traits);
    }
};

export const trackMixpanelEvent = (eventName: string, properties?: Record<string, any>) => {
    if (!isInitialized) {
        return;
    }

    mixpanel.track(eventName, properties);
};

export const resetMixpanel = () => {
    if (!isInitialized) {
        return;
    }

    mixpanel.reset();
};
